import { inject } from '@angular/core';
import { NavigationItemService } from '@features/partners/builder/settings/menu/navigation-item/navigation-item.service';

export const internalRoutesResolver = () => inject(NavigationItemService).internalRoutes$;
